import React from 'react'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import { selectActiveProcesses } from '../../redux/selectors/processing.selectors'
import { ProcessingNotification } from './processingNotification'

/**
 * Componente que renderiza todas las notificaciones flotantes activas.
 * Esta colocado a nivel de App/Layout para que persista en todas las páginas.
 */
export const ProcessingNotificationManager: React.FC = () => {
  const activeProcesses = useSelector(selectActiveProcesses)

  if (activeProcesses.length === 0) {
    return null
  }

  return (
    <Box>
      {activeProcesses.map((process, index) => (
        <Box
          key={process.processId}
          style={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            // Stack notifications vertically if multiple
            transform: `translateY(-${index * 120}px)`,
            zIndex: 1400 + index
          }}
        >
          <ProcessingNotification processId={process.processId} />
        </Box>
      ))}
    </Box>
  )
}
